const STORE_NAME = 'posAllergens';
const INSTALL_KEY = Symbol.for('rickymau.posAllergenDialog');

function createPosAllergenStore() {
    return {
        allergens: [],
        compositeNote: false,
        open: false,
        sequence: 0,
        title: '',
        variantId: '',

        close() {
            this.open = false;

            return true;
        },

        show(payload = {}) {
            this.variantId = String(payload.variantId ?? '');
            this.title = String(payload.title ?? '');
            this.allergens = (
                Array.isArray(payload.allergens) ? payload.allergens : []
            ).map((allergen) => ({
                name: String(allergen?.name ?? ''),
                svgUrl: String(allergen?.svgUrl ?? ''),
            }));
            this.compositeNote = payload.compositeNote === true;
            this.open = true;
            this.sequence += 1;

            return true;
        },
    };
}

function installPosAllergenDialog({
    documentTarget = document,
    windowTarget = window,
} = {}) {
    windowTarget[INSTALL_KEY]?.dispose();

    let store = null;
    let disposed = false;

    function registerStore() {
        if (disposed || !windowTarget.Alpine || store !== null) {
            return;
        }

        store = createPosAllergenStore();
        windowTarget.Alpine.store(STORE_NAME, store);
    }

    function closeOnNavigation() {
        store?.close();
    }

    documentTarget.addEventListener('alpine:init', registerStore);
    documentTarget.addEventListener('livewire:navigating', closeOnNavigation);
    registerStore();

    const installation = {
        dispose() {
            if (disposed) {
                return;
            }

            disposed = true;
            documentTarget.removeEventListener('alpine:init', registerStore);
            documentTarget.removeEventListener(
                'livewire:navigating',
                closeOnNavigation,
            );
            store?.close();

            if (windowTarget[INSTALL_KEY] === installation) {
                delete windowTarget[INSTALL_KEY];
            }
        },
    };
    windowTarget[INSTALL_KEY] = installation;

    return installation;
}

export { createPosAllergenStore, installPosAllergenDialog };
